/* ============
 * Postal Transformer
 * ============
 *
 * Postal transformer.
 */

import Transformer from './transformer';

export default class PostalTransformer extends Transformer {

  static fetch(item) {
    return {
      id: item.id,
      postalCode: item.postal_code,
      cityId: item.city_id,
      cityName: item.city_name,
      municipalityId: item.municipality_id,
      stateId: item.state_id,
    };
  }

  static send(item) {
    return {
      id: item.id,
      postal_code: item.postalCode,
      city_id: item.cityId,
      municipality_id: item.municipalityId,
      state_id: item.stateId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/postal.js